module.exports = __webpack_public_path__ + "media/images/icons/tower-9b13b2cc72d96d91e0477d615fe4801e.svg";